"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'auth/';
exports.default = {
  CHANGED: _DOMAIN + 'CHANGED',
  CREATE_ANONYMOUS_USER_INIT: _DOMAIN + 'CREATE_ANONYMOUS_USER_INIT',
  CREATE_ANONYMOUS_USER_SUCCESS: _DOMAIN + 'CREATE_ANONYMOUS_USER_SUCCESS',
  CREATE_ANONYMOUS_USER_FAILURE: _DOMAIN + 'CREATE_ANONYMOUS_USER_FAILURE',
  CREATE_GOOGLE_USER_INIT: _DOMAIN + 'CREATE_GOOGLE_USER_INIT',
  CREATE_GOOGLE_USER_SUCCESS: _DOMAIN + 'CREATE_GOOGLE_USER_SUCCESS',
  CREATE_GOOGLE_USER_FAILURE: _DOMAIN + 'CREATE_GOOGLE_USER_FAILURE',
  CREATE_FACEBOOK_USER_INIT: _DOMAIN + 'CREATE_FACEBOOK_USER_INIT',
  CREATE_FACEBOOK_USER_SUCCESS: _DOMAIN + 'CREATE_FACEBOOK_USER_SUCCESS',
  CREATE_FACEBOOK_USER_FAILURE: _DOMAIN + 'CREATE_FACEBOOK_USER_FAILURE',
  GET_AUTH_INFO_INIT: _DOMAIN + 'GET_AUTH_INFO_INIT',
  GET_AUTH_INFO_SUCCESS: _DOMAIN + 'GET_AUTH_INFO_SUCCESS',
  GET_AUTH_INFO_FAILURE: _DOMAIN + 'GET_AUTH_INFO_FAILURE',
  SIGN_OUT_INIT: _DOMAIN + 'SIGN_OUT_INIT',
  SIGN_OUT_SUCCESS: _DOMAIN + 'SIGN_OUT_SUCCESS',
  SIGN_OUT_FAILURE: _DOMAIN + 'SIGN_OUT_FAILURE',
  DEVICE_SIGN_OUT_INIT: _DOMAIN + 'DEVICE_SIGN_OUT_INIT',
  DEVICE_SIGN_OUT_SUCCESS: _DOMAIN + 'DEVICE_SIGN_OUT_SUCCESS',
  DEVICE_SIGN_OUT_FAILURE: _DOMAIN + 'DEVICE_SIGN_OUT_FAILURE',
  LINK_GOOGLE_USER_INIT: _DOMAIN + 'LINK_GOOGLE_USER_INIT',
  LINK_GOOGLE_USER_SUCCESS: _DOMAIN + 'LINK_GOOGLE_USER_SUCCESS',
  LINK_GOOGLE_USER_FAILURE: _DOMAIN + 'LINK_GOOGLE_USER_FAILURE',
  LINK_FACEBOOK_USER_INIT: _DOMAIN + 'LINK_FACEBOOK_USER_INIT',
  LINK_FACEBOOK_USER_SUCCESS: _DOMAIN + 'LINK_FACEBOOK_USER_SUCCESS',
  LINK_FACEBOOK_USER_FAILURE: _DOMAIN + 'LINK_FACEBOOK_USER_FAILURE',
  LINK_FACEBOOK_USER_CANCEL: _DOMAIN + 'LINK_FACEBOOK_USER_CANCEL',
  LINK_GOOGLE_USER_CANCEL: _DOMAIN + 'LINK_GOOGLE_USER_CANCEL',
  CREATE_FACEBOOK_USER_CANCEL: _DOMAIN + 'CREATE_FACEBOOK_USER_CANCEL',
  CREATE_GOOGLE_USER_CANCEL: _DOMAIN + 'CREATE_GOOGLE_USER_CANCEL'
};